<template>
	<a-modal
		class="g-header-carousel-banner-edit-modal"
		:visible="visible"
		title="头部模块编辑"
		width="706px"
		:mask-closable="false"
		:destroy-on-close="true"
		@cancel="onCancel"
	>
		<div class="g-header-carousel-banner-edit" @click="clearSelection">
			<div class="g-header-carousel-banner-edit__stage" @click.stop>
				<button
					v-if="form.items.length > 1"
					type="button"
					class="g-header-carousel-banner-edit__nav g-header-carousel-banner-edit__nav--prev"
					@click="goPrev"
				>
					<i class="mbm-iconfont mbm-youjiantou g-header-carousel-banner-edit__nav-icon--prev"></i>
				</button>

				<div
					class="g-header-carousel-banner-edit__preview"
					:style="previewWrapStyle"
				>
					<img
						v-if="selectedSlide && getImageUrl(selectedSlide)"
						:src="getImageUrl(selectedSlide)"
						class="g-header-carousel-banner-edit__preview-bg"
						alt=""
					/>
					<div v-else class="g-header-carousel-banner-edit__preview-empty">
						<i class="mbm-iconfont mbm-tupian"></i>
					</div>
					<div
						v-if="selectedSlide"
						class="g-header-carousel-banner-edit__text"
					>
						<input
							v-model="selectedSlide.title"
							type="text"
							class="g-header-carousel-banner-edit__title-input"
							:style="{ color: form.titleColor }"
							maxlength="40"
							placeholder="输入主标题"
						/>
						<input
							v-model="selectedSlide.subtitle"
							type="text"
							class="g-header-carousel-banner-edit__subtitle-input"
							:style="{ color: form.subtitleColor }"
							maxlength="60"
							placeholder="输入副标题"
						/>
					</div>
					<div
						v-if="form.items.length > 1"
						class="g-header-carousel-banner-edit__dots-preview"
					>
						<span
							v-for="(slide, index) in form.items"
							:key="`preview-dot-${slide.id}`"
							class="g-header-carousel-banner-edit__dot-preview"
							:class="{ 'is-active': selectedIndex === index }"
							:style="getDotPreviewStyle(index)"
						></span>
					</div>
				</div>

				<button
					v-if="form.items.length > 1"
					type="button"
					class="g-header-carousel-banner-edit__nav g-header-carousel-banner-edit__nav--next"
					@click="goNext"
				>
					<i class="mbm-iconfont mbm-youjiantou"></i>
				</button>
			</div>

			<div
				class="g-header-carousel-banner-edit__thumb-row"
				@click.stop
			>
				<EditListSortGroup
					ref="editGrid"
					class="g-header-carousel-banner-edit__thumbs"
					@dragover="onSortDragOver"
				>
					<div
						v-for="(slide, index) in form.items"
						:key="slide.id"
						:data-sort-id="slide.id"
						class="g-header-carousel-banner-edit__thumb-wrap"
						:class="[
							{ 'is-active': selectedIndex === index },
							getEditListSortItemClass(dragId, slide.id, dragOverId),
						]"
					>
						<div
							class="g-header-carousel-banner-edit__thumb"
							:class="{ 'is-selected': selectedIndex === index }"
							draggable="true"
							@dragstart="onDragStart(slide.id, $event)"
							@dragend="onDragEnd"
							@click="selectSlide(index)"
						>
							<UploadProgressPanel
								v-if="isUploading && selectedIndex === index"
								:tasks="uploadTasks"
								variant="item"
								hide-filename
							/>
							<template v-else>
								<img v-if="getImageUrl(slide)" :src="getImageUrl(slide)" alt="" draggable="false" />
								<i v-else class="mbm-iconfont mbm-tupian"></i>
								<button
									type="button"
									class="g-header-carousel-banner-edit__thumb-delete"
									@click.stop="deleteSlide(index)"
								>×</button>
							</template>
						</div>

						<div
							v-if="selectedIndex === index"
							class="g-header-carousel-banner-edit__panel g-header-carousel-banner-edit__panel--arrow g-header-carousel-banner-edit__panel--float"
							@click.stop
						>
							<div class="g-header-carousel-banner-edit__link-row">
								<i class="mbm-iconfont mbm-lianjie"></i>
								<span :class="{ 'is-empty': !jumpLinkLabel }">{{ jumpLinkLabel || '未设置链接' }}</span>
							</div>
							<div class="g-header-carousel-banner-edit__toolbar">
								<button type="button" class="g-header-carousel-banner-edit__action" @click="triggerImageSelect">换图</button>
								<button type="button" class="g-header-carousel-banner-edit__action" @click="jumpLinkVisible = true">换链接</button>
								<span class="g-header-carousel-banner-edit__action-wrap">
									<button
										type="button"
										class="g-header-carousel-banner-edit__action"
										:class="{ 'is-active': activePanel === 'radius' }"
										@click="togglePanel('radius')"
									>圆角</button>
									<div v-if="activePanel === 'radius'" class="g-header-carousel-banner-edit__sub-panel">
										<span class="g-header-carousel-banner-edit__sub-label">圆角 (px)</span>
										<a-input-number
											v-model:value="radiusDraft"
											:min="0"
											:max="40"
											:precision="0"
											class="g-header-carousel-banner-edit__sub-input"
										/>
										<button type="button" class="g-header-carousel-banner-edit__sub-confirm" @click="applyRadius">确定</button>
									</div>
								</span>
								<span class="g-header-carousel-banner-edit__action-wrap">
									<button
										type="button"
										class="g-header-carousel-banner-edit__action"
										:class="{ 'is-active': activePanel === 'autoplay' || form.autoplay }"
										@click="togglePanel('autoplay')"
									>自动切换</button>
									<div v-if="activePanel === 'autoplay'" class="g-header-carousel-banner-edit__sub-panel">
										<span class="g-header-carousel-banner-edit__sub-label">切换 (秒)</span>
										<a-input-number
											v-model:value="autoplayIntervalDraft"
											:min="1"
											:max="60"
											:precision="0"
											class="g-header-carousel-banner-edit__sub-input"
										/>
										<button type="button" class="g-header-carousel-banner-edit__sub-confirm" @click="applyAutoplayInterval">确定</button>
									</div>
								</span>
								<span class="g-header-carousel-banner-edit__action-wrap">
									<button
										type="button"
										class="g-header-carousel-banner-edit__action"
										:class="{ 'is-active': activePanel === 'height' }"
										@click="togglePanel('height')"
									>高度</button>
									<div v-if="activePanel === 'height'" class="g-header-carousel-banner-edit__sub-panel">
										<span class="g-header-carousel-banner-edit__sub-label">高度 (px)</span>
										<a-input-number
											v-model:value="heightDraft"
											:min="80"
											:max="800"
											:precision="0"
											class="g-header-carousel-banner-edit__sub-input"
										/>
										<button type="button" class="g-header-carousel-banner-edit__sub-confirm" @click="applyHeight">确定</button>
									</div>
								</span>
								<button
									type="button"
									class="g-header-carousel-banner-edit__action g-header-carousel-banner-edit__action--danger-text"
									:disabled="form.items.length <= 1"
									@click="deleteSlide(index)"
								>删除</button>
								<div class="g-header-carousel-banner-edit__colors">
									<ColorPicker
										v-model="form.titleColor"
										title="主标题颜色"
										@change="onTitleColorInput"
									/>
									<ColorPicker
										v-model="form.subtitleColor"
										title="副标题颜色"
										@change="onSubtitleColorInput"
									/>
									<ColorPicker
										v-model="form.dotActiveColor"
										title="选中指示点颜色"
										@change="onDotActiveColorInput"
									/>
									<ColorPicker
										v-model="form.dotColor"
										title="指示点颜色"
										@change="onDotColorInput"
									/>
								</div>
							</div>
						</div>
					</div>

					<div
						v-if="form.items.length < maxSlides"
						class="g-header-carousel-banner-edit__thumb g-header-carousel-banner-edit__thumb--add"
						@click="addSlide"
					>
						<span>+</span>
					</div>
				</EditListSortGroup>
				<p class="g-header-carousel-banner-edit__sort-tip">拖动排序</p>
			</div>
		</div>

		<template #footer>
			<button type="button" class="g-header-carousel-banner-edit__footer-btn" @click="onCancel">取消</button>
			<button type="button" class="g-header-carousel-banner-edit__footer-btn is-confirm" :disabled="isUploading" @click="onConfirm">确定</button>
		</template>

		<input
			ref="fileInput"
			type="file"
			accept="image/*"
			class="g-header-carousel-banner-edit__file-input"
			@change="onFileChange"
		/>

		<JumpLink
			:visible="jumpLinkVisible"
			:jumpLink="selectedSlide?.jumpLink || emptyJumpLink"
			:linkTypes="['qrcode']"
			@submit="onJumpLinkSubmit"
			@cancel="jumpLinkVisible = false"
		/>
	</a-modal>
</template>

<script>
	import EditListSortGroup from './EditListSortGroup.vue';
	import ColorPicker from './ColorPicker.vue';
	import {
		getEditListSortItemClass,
		handleEditListSortDragEnd,
		handleEditListSortDragOver,
		handleEditListSortDragStart,
		resolveSelectedIndexAfterListMove,
	} from '../utils/editListDragSort.js';
	import JumpLink from '@/components/jumpLink.vue';
	import { getSwatchBorderColor, normalizeHexColor } from '../utils/richText.js';
	import { filterValidLocalFiles, revokeLocalImageUrl } from '../utils/localImage.js';
	import UploadProgressPanel from './UploadProgressPanel.vue';
	import {
		createUploadTasks,
		updateUploadTaskProgress,
		uploadHeaderMediaFiles,
	} from '../utils/uploadHeaderMedia.js';
	import { createEmptyJumpLink, formatJumpLinkLabel } from '../utils/jumpLink.js';
	import {
		createDefaultHeaderCarouselSlide,
		getHeaderCarouselBannerDefaults,
		getHeaderCarouselImageUrl,
		HEADER_CAROUSEL_DEFAULT_BORDER_RADIUS,
		HEADER_CAROUSEL_DEFAULT_HEIGHT,
		HEADER_CAROUSEL_DEFAULT_AUTOPLAY_INTERVAL,
		HEADER_CAROUSEL_MAX_SLIDES,
		HEADER_CAROUSEL_VARIANT_BANNER,
		normalizeHeaderCarouselData,
	} from '../utils/headerCarousel.js';
	import { ensureEditFloatPanelVisible } from '../utils/editPanelAlign.js';

	export default {
		name: 'GHeaderCarouselBannerEditModal',
		components: { EditListSortGroup, JumpLink, UploadProgressPanel, ColorPicker },
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
			value: {
				type: Object,
				default: () => ({}),
			},
		},
		emits: ['update:visible', 'confirm', 'cancel'],
		data() {
			return {
				form: getHeaderCarouselBannerDefaults(),
				selectedIndex: 0,
				activePanel: '',
				heightDraft: HEADER_CAROUSEL_DEFAULT_HEIGHT,
				radiusDraft: HEADER_CAROUSEL_DEFAULT_BORDER_RADIUS,
				autoplayIntervalDraft: Math.round(HEADER_CAROUSEL_DEFAULT_AUTOPLAY_INTERVAL / 1000),
				dragId: '',
				dragOverId: '',
				jumpLinkVisible: false,
				emptyJumpLink: createEmptyJumpLink(),
				maxSlides: HEADER_CAROUSEL_MAX_SLIDES,
				isUploading: false,
				uploadTasks: [],
			};
		},
		computed: {
			selectedSlide() {
				return this.form.items[this.selectedIndex] || null;
			},
			previewWrapStyle() {
				const radius = this.form.borderRadius;
				return {
					height: `${this.form.height}px`,
					borderRadius: `0 0 ${radius}px ${radius}px`,
				};
			},
			jumpLinkLabel() {
				return formatJumpLinkLabel(this.selectedSlide?.jumpLink);
			},
		},
		watch: {
			visible(val) {
				if (val) {
					this.selectedIndex = 0;
					this.activePanel = '';
					this.dragId = '';
					this.dragOverId = '';
					this.syncForm();
				}
			},
			value: {
				deep: true,
				handler() {
					if (this.visible) {
						this.syncForm();
					}
				},
			},
		},
		methods: {
			getEditListSortItemClass,
			syncForm() {
				const normalized = normalizeHeaderCarouselData(this.value);
				this.form = {
					...normalized,
					variant: HEADER_CAROUSEL_VARIANT_BANNER,
				};
				this.heightDraft = this.form.height;
				this.radiusDraft = this.form.borderRadius;
				this.autoplayIntervalDraft = Math.max(1, Math.round(this.form.autoplayInterval / 1000));
				if (this.selectedIndex >= this.form.items.length) {
					this.selectedIndex = Math.max(0, this.form.items.length - 1);
				}
			},
			normalizeColor(color) {
				return normalizeHexColor(color);
			},
			getSwatchStyle(color) {
				const normalized = normalizeHexColor(color);
				return {
					background: normalized,
					borderColor: getSwatchBorderColor(normalized),
				};
			},
			getImageUrl(slide) {
				return getHeaderCarouselImageUrl(slide?.image);
			},
			getDotPreviewStyle(index) {
				const isActive = this.selectedIndex === index;
				return {
					background: isActive ? this.form.dotActiveColor : this.form.dotColor,
					width: '14px',
					height: '4px',
					borderRadius: '2px',
				};
			},
			selectSlide(index) {
				this.selectedIndex = index;
				this.activePanel = '';
				this.ensureActivePanelVisible();
			},
			ensureActivePanelVisible() {
				ensureEditFloatPanelVisible(this, {
					wrapSelector: '.g-header-carousel-banner-edit__thumb-wrap',
					panelSelector: '.g-header-carousel-banner-edit__panel--float',
				});
			},
			clearSelection() {
				this.activePanel = '';
			},
			goPrev() {
				const next = (this.selectedIndex - 1 + this.form.items.length) % this.form.items.length;
				this.selectSlide(next);
			},
			goNext() {
				const next = (this.selectedIndex + 1) % this.form.items.length;
				this.selectSlide(next);
			},
			togglePanel(panel) {
				this.activePanel = this.activePanel === panel ? '' : panel;
				if (panel === 'height') {
					this.heightDraft = this.form.height;
				}
				if (panel === 'radius') {
					this.radiusDraft = this.form.borderRadius;
				}
				if (panel === 'autoplay') {
					this.autoplayIntervalDraft = Math.max(1, Math.round(this.form.autoplayInterval / 1000));
				}
				if (this.activePanel) {
					this.ensureActivePanelVisible();
				}
			},
			applyHeight() {
				this.form.height = Math.max(80, Number(this.heightDraft) || HEADER_CAROUSEL_DEFAULT_HEIGHT);
				this.activePanel = '';
			},
			applyRadius() {
				this.form.borderRadius = Math.max(0, Number(this.radiusDraft) || 0);
				this.activePanel = '';
			},
			applyAutoplayInterval() {
				this.form.autoplayInterval = Math.max(1, Number(this.autoplayIntervalDraft) || 1) * 1000;
				this.form.autoplay = true;
				this.activePanel = '';
			},
			onDotColorInput(color) {
				this.form.dotColor = color;
			},
			onDotActiveColorInput(color) {
				this.form.dotActiveColor = color;
			},
			onTitleColorInput(color) {
				this.form.titleColor = color;
			},
			onSubtitleColorInput(color) {
				this.form.subtitleColor = color;
			},
			triggerImageSelect() {
				this.$refs.fileInput.value = '';
				this.$refs.fileInput.click();
			},
			async onFileChange(event) {
				const file = filterValidLocalFiles(Array.from(event.target.files || []), 1)[0];
				event.target.value = '';
				if (!file || !this.selectedSlide) return;
				this.isUploading = true;
				this.uploadTasks = createUploadTasks([file]);
				try {
					const [item] = await uploadHeaderMediaFiles(this, {
						type: 'image',
						files: [file],
						onProgress: payload => updateUploadTaskProgress(this.uploadTasks, payload),
					});
					if (this.selectedSlide.image?.local) {
						revokeLocalImageUrl(this.selectedSlide.image.previewUrl);
					}
					this.selectedSlide.image = item;
				} catch (error) {
					this.$message?.error?.('上传失败');
				} finally {
					this.isUploading = false;
					this.uploadTasks = [];
				}
			},
			onJumpLinkSubmit(link) {
				if (this.selectedSlide) {
					this.selectedSlide.jumpLink = link?.type ? { ...link } : null;
				}
				this.jumpLinkVisible = false;
			},
			addSlide() {
				if (this.form.items.length >= this.maxSlides) return;
				const slide = createDefaultHeaderCarouselSlide(
					this.form.items.length,
					HEADER_CAROUSEL_VARIANT_BANNER,
				);
				this.form.items.push(slide);
				this.selectedIndex = this.form.items.length - 1;
			},
			deleteSlide(index) {
				if (this.form.items.length <= 1) return;
				this.form.items.splice(index, 1);
				if (this.selectedIndex >= this.form.items.length) {
					this.selectedIndex = this.form.items.length - 1;
				}
			},
			onDragStart(id, event) {
				handleEditListSortDragStart(this, id);
				event.dataTransfer.effectAllowed = 'move';
			},
			onSortDragOver(event) {
				handleEditListSortDragOver(event, this.$refs.editGrid, this);
			},
			onDragEnd() {
				handleEditListSortDragEnd(this, this.$refs.editGrid, this.form.items, this, (result) => {
					this.selectedIndex = resolveSelectedIndexAfterListMove(
						this.selectedIndex,
						result.fromIndex,
						result.toIndex,
					);
				});
			},
			onCancel() {
				this.$emit('update:visible', false);
				this.$emit('cancel');
			},
			onConfirm() {
				this.$emit('confirm', normalizeHeaderCarouselData(this.form));
				this.$emit('update:visible', false);
			},
		},
	};
</script>

<style scoped lang="less">
	.g-header-carousel-banner-edit {
		overflow: visible;
	}

	.g-header-carousel-banner-edit__stage {
		display: flex;
		align-items: center;
		gap: 12px;
		margin-bottom: 16px;
	}

	.g-header-carousel-banner-edit__nav {
		flex-shrink: 0;
		width: 32px;
		height: 32px;
		border: 1px solid #eceef2;
		border-radius: 50%;
		background: #fff;
		color: #666;
		cursor: pointer;
		display: inline-flex;
		align-items: center;
		justify-content: center;

		&:hover {
			color: #285af9;
			border-color: #285af9;
		}

		i {
			font-size: 14px;
			line-height: 1;
		}
	}

	.g-header-carousel-banner-edit__nav-icon--prev {
		display: inline-block;
		transform: rotate(180deg);
	}

	.g-header-carousel-banner-edit__preview {
		position: relative;
		flex: 1;
		min-width: 0;
		overflow: hidden;
		background: #f5f5f5;
	}

	.g-header-carousel-banner-edit__preview-bg {
		position: absolute;
		inset: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.g-header-carousel-banner-edit__preview-empty {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
		color: #bfbfbf;

		i {
			font-size: 36px;
		}
	}

	.g-header-carousel-banner-edit__text {
		position: absolute;
		inset: 0;
		z-index: 2;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 24px 28px;
		pointer-events: auto;
	}

	.g-header-carousel-banner-edit__title-input,
	.g-header-carousel-banner-edit__subtitle-input {
		width: 100%;
		max-width: 520px;
		border: none;
		background: transparent;
		text-align: center;
		outline: none;
		padding: 0;

		&::placeholder {
			color: rgba(255, 255, 255, 0.55);
		}
	}

	.g-header-carousel-banner-edit__title-input {
		font-size: 32px;
		font-weight: 700;
		line-height: 1.4;
	}

	.g-header-carousel-banner-edit__subtitle-input {
		margin-top: 10px;
		font-size: 22px;
		font-weight: 400;
		line-height: 1.4;
	}

	.g-header-carousel-banner-edit__dots-preview {
		position: absolute;
		left: auto;
		right: 12px;
		bottom: 10px;
		z-index: 2;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 5px;
		pointer-events: none;
	}

	.g-header-carousel-banner-edit__dot-preview {
		display: inline-block;
		flex-shrink: 0;
		vertical-align: middle;
	}

	.g-header-carousel-banner-edit__thumb-row {
		padding-left: 42px;
		overflow: visible;
	}

	.g-header-carousel-banner-edit__thumbs {
		display: flex;
		align-items: flex-start;
		flex-wrap: wrap;
		gap: 10px;
	}

	.g-header-carousel-banner-edit__thumb-wrap {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		z-index: 0;

		&.is-active {
			z-index: 2;
		}
	}

	.g-header-carousel-banner-edit__thumb {
		position: relative;
		width: 72px;
		height: 72px;
		border: 2px solid transparent;
		overflow: hidden;
		border-radius: 4px;
		background: #fafafa;
		cursor: pointer;
		box-sizing: border-box;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			display: block;
		}

		i {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 100%;
			height: 100%;
			font-size: 24px;
			color: #bfbfbf;
		}

		&.is-selected {
			border-color: #285af9;
		}

		&.is-dragging {
			opacity: 0.45;
		}

		&.is-drag-over {
			box-shadow: inset 0 0 0 2px #285af9;
		}

		&--add {
			display: flex;
			align-items: center;
			justify-content: center;
			border: 1px dashed #d9d9d9;
			color: #999;
			font-size: 24px;
			line-height: 1;
		}
	}

	.g-header-carousel-banner-edit__thumb-delete {
		position: absolute;
		top: 2px;
		right: 2px;
		width: 16px;
		height: 16px;
		border: none;
		border-radius: 50%;
		background: rgba(0, 0, 0, 0.55);
		color: #fff;
		font-size: 12px;
		line-height: 16px;
		padding: 0;
		cursor: pointer;
	}

	.g-header-carousel-banner-edit__sort-tip {
		margin: 8px 0 0;
		font-size: 12px;
		color: #999;
	}

	.g-header-carousel-banner-edit__panel {
		background: #fff;
		border: 1px solid #eceef2;
		border-radius: 4px;
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
		overflow: visible;
		width: max-content;
		max-width: 100%;

		&--float {
			position: absolute;
			top: calc(100% + 8px);
			left: 0;
			z-index: 10;
			display: inline-block;
			width: auto;
			max-width: none;
		}

		&--arrow::before {
			content: '';
			position: absolute;
			top: -5px;
			left: 36px;
			width: 10px;
			height: 10px;
			background: #fff;
			border-left: 1px solid #eceef2;
			border-top: 1px solid #eceef2;
			transform: translateX(-50%) rotate(45deg);
			z-index: 1;
		}
	}

	.g-header-carousel-banner-edit__link-row {
		display: flex;
		align-items: center;
		gap: 8px;
		min-height: 40px;
		padding: 0 14px;
		border-bottom: 1px solid #f0f0f0;
		font-size: 13px;
		color: #333;
		white-space: nowrap;

		i {
			color: #999;
			font-size: 14px;
		}

		.is-empty {
			color: #999;
		}
	}

	.g-header-carousel-banner-edit__toolbar {
		display: flex;
		align-items: center;
		flex-wrap: nowrap;
		gap: 0;
		min-height: 40px;
		padding: 0 10px;
	}

	.g-header-carousel-banner-edit__action-wrap {
		position: relative;
		display: inline-flex;
		flex-shrink: 0;
	}

	.g-header-carousel-banner-edit__action {
		border: none;
		background: transparent;
		padding: 0 10px;
		font-size: 13px;
		color: #285af9;
		cursor: pointer;
		line-height: 32px;
		white-space: nowrap;

		&:hover,
		&.is-active {
			color: #1d4ed8;
		}

		&--danger-text {

			&:hover {
				color: #cf1322;
			}

			&:disabled {
				color: #ccc;
				cursor: not-allowed;
			}
		}
	}

	.g-header-carousel-banner-edit__colors {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		margin-left: auto;
		padding-left: 8px;
	}

	.g-header-carousel-banner-edit__swatch {
		position: relative;
		display: inline-block;
		width: 18px;
		height: 18px;
		border: 1px solid #b0b0b0;
		border-radius: 3px;
		cursor: pointer;
		overflow: hidden;
		flex-shrink: 0;
		box-sizing: border-box;

		&:hover {
			box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.25);
		}
	}

	.g-header-carousel-banner-edit__color-input {
		position: absolute;
		inset: 0;
		width: 100%;
		height: 100%;
		padding: 0;
		border: none;
		opacity: 0;
		cursor: pointer;
	}

	.g-header-carousel-banner-edit__sub-panel {
		position: absolute;
		left: 50%;
		top: calc(100% + 6px);
		z-index: 2;
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 10px 12px;
		background: #fff;
		border: 1px solid #eceef2;
		border-radius: 4px;
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
		transform: translateX(-50%);
		white-space: nowrap;
	}

	.g-header-carousel-banner-edit__sub-label {
		font-size: 12px;
		color: #666;
	}

	.g-header-carousel-banner-edit__sub-input {
		width: 88px;
	}

	.g-header-carousel-banner-edit__sub-confirm {
		border: none;
		background: #285af9;
		color: #fff;
		padding: 0 12px;
		height: 28px;
		border-radius: 4px;
		font-size: 12px;
		cursor: pointer;
	}

	.g-header-carousel-banner-edit__file-input {
		display: none;
	}

	.g-header-carousel-banner-edit__footer-btn {
		min-width: 88px;
		height: 32px;
		border: 1px solid #d9d9d9;
		border-radius: 4px;
		background: #fff;
		color: #666;
		font-size: 14px;
		cursor: pointer;

		&.is-confirm {
			border-color: #285af9;
			background: #285af9;
			color: #fff;
		}
	}
</style>

<style lang="less">
	.g-header-carousel-banner-edit-modal {
		.ant-modal-body {
			overflow: visible;
		}
	}
</style>
